var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 0H4.375C1.95875 0 0 1.95875 0 4.375V15.625C0 18.0413 1.95875 20 4.375 20H15.625C18.0413 20 20 18.0413 20 15.625V4.375C20 1.95875 18.0413 0 15.625 0ZM18.75 15.625C18.75 17.3509 17.3509 18.75 15.625 18.75H4.375C2.6491 18.75 1.25 17.3509 1.25 15.625V4.375C1.25 2.6491 2.6491 1.25 4.375 1.25H15.625C17.3509 1.25 18.75 2.6491 18.75 4.375V15.625Z",
    fill: "#1F342F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.375H5C4.6548 4.375 4.375 4.6548 4.375 5V6.25C4.375 6.5952 4.6548 6.875 5 6.875H6.25C6.5952 6.875 6.875 6.5952 6.875 6.25V5C6.875 4.6548 6.5952 4.375 6.25 4.375Z",
    fill: "#1F342F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.75H5C4.6548 8.75 4.375 9.0298 4.375 9.375V10.625C4.375 10.9702 4.6548 11.25 5 11.25H6.25C6.5952 11.25 6.875 10.9702 6.875 10.625V9.375C6.875 9.0298 6.5952 8.75 6.25 8.75Z",
    fill: "#1F342F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.125H5C4.6548 13.125 4.375 13.4048 4.375 13.75V15C4.375 15.3452 4.6548 15.625 5 15.625H6.25C6.5952 15.625 6.875 15.3452 6.875 15V13.75C6.875 13.4048 6.5952 13.125 6.25 13.125Z",
    fill: "#1F342F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5H8.125V6.25H15.625V5Z",
    fill: "#1F342F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 9.375H8.125V10.625H15.625V9.375Z",
    fill: "#1F342F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.75H8.125V15H15.625V13.75Z",
    fill: "#1F342F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentList);
export default __webpack_public_path__ + "static/media/document-list.7f8d89ae8aed98ef7ea5e7fbd4a52aa1.svg";
export { ForwardRef as ReactComponent };